import {
    ApplicationRef, ComponentFactoryResolver, ComponentRef,
    EmbeddedViewRef, Injectable, Injector, Optional, SkipSelf
} from '@angular/core';

import { PortalInjector } from '../portal/portal-injector';
import { OverlayContainer } from '../overlay/overlay-container';

@Injectable({
    providedIn: 'root',
})

export class DomService {
    constructor(
        private readonly injector: Injector,
        private readonly appRef: ApplicationRef,
        private readonly overlayContainer: OverlayContainer,
        private readonly componentFactoryResolver: ComponentFactoryResolver,
    ) {}

    attachComponentPortal<T>(component: ComponentType<T>, injector?: PortalInjector): ComponentRef<T> {
        const componentRef: ComponentRef<T> = this.componentFactoryResolver.resolveComponentFactory(component)
            .create(injector ? injector : this.injector);

        this.appRef.attachView(componentRef.hostView);

        this.overlayContainer.getContainerElement().appendChild(this.getComponentRootNode(componentRef));

        return componentRef;
    }

    private getComponentRootNode = (componentRef: ComponentRef<any>): HTMLElement => {
        return (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    }
}

export function DOM_SERVICE_PROVIDER_FACTORY(
    injector: Injector,
    appRef: ApplicationRef,
    parentContainer: DomService,
    overlayContainer: OverlayContainer,
    componentFactoryResolver: ComponentFactoryResolver,
) {
    return parentContainer || new DomService(injector, appRef, overlayContainer, componentFactoryResolver);
}

export const DOM_SERVICE_PROVIDER = {
    provide: DomService,
    deps: [
        [
            new Optional(),
            new SkipSelf(),
            DomService
        ],
        ComponentFactoryResolver,
        ApplicationRef,
        Injector,
        OverlayContainer
    ],
    useFactory: DOM_SERVICE_PROVIDER_FACTORY
};

export interface ComponentType<T> {
    new(...args: any[]): T;
}
